import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDownOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardArrowDownOutlined.js
// module id = 4312
// module chunks = 2